import { useInfiniteQuery } from '@tanstack/react-query';
import qs from 'qs';
import compact from '../../../../utils/compact';
import type {
  AgentApiProvidedJobPostsIndex,
  AgentApiProvidedJobPostsRecord,
} from '@/types/serializers';

export type ProvidedJobPost = AgentApiProvidedJobPostsRecord;
export interface SearchQuery {
  company_ids: number[];
  job_position_name?: string;
  // 都道府県コード絞り込み（Issue #3401）
  prefecture_codes?: number[];
  min_salary?: string;
  max_salary?: string;
  salary?: string;
  custom_tag_ids: number[];
  custom_tag_match?: 'all' | 'any';
  list_ids: number[];
  search_column_alpha?: string;
  search_keyword_alpha?: string;
  search_operator_alpha?: string;
  search_column_beta?: string;
  search_keyword_beta?: string;
  search_operator_beta?: string;
  search_column_gamma?: string;
  search_keyword_gamma?: string;
  search_operator_gamma?: string;
  is_include_archived?: boolean;
  is_salary_empty?: boolean;
  status?: string[];
  sort: string;
  job_source_id?: number;
  created_type?: string;
  is_available?: boolean;
}

export default function useProvidedJobPosts(
  searchQuery: SearchQuery,
  options?: { enabled?: boolean }
) {
  return useInfiniteQuery({
    queryKey: ['/agent/api/provided_job_posts', searchQuery],
    enabled: options?.enabled ?? true,
    queryFn: async ({ pageParam = 1 }) => {
      const query = qs.stringify(
        { search_query: compact(searchQuery) },
        { arrayFormat: 'brackets' }
      );
      const response = await fetch(`/agent/api/provided_job_posts.json?${query}&page=${pageParam}`);
      const data: AgentApiProvidedJobPostsIndex = await response.json();
      return data;
    },
    getNextPageParam: (lastPage, allPages) => {
      if (lastPage.is_last_page) {
        return undefined;
      }
      return allPages.length + 1;
    },
    initialPageParam: 1,
  });
}
